export const DOCUMENT_RECORDS_NAMESPACE = '/v1/records';
export const PRESENCE_NAMESPACE = '/v1/presence';
export const COMMUNICATIONS_NAMESPACE = '/v1/communications';
//# sourceMappingURL=realtime-namespaces.js.map